import snakecaseKeys from 'snakecase-keys';
import { restClient } from '../../client';


export type PsychiatryOnlyUtmSource = {
  value: string;
  partner: string;
  description: string;
  url: string;
  isPaidTraffic: boolean;
  active: boolean;
};


export const getPsychiatryOnlyUtmSources = () => restClient.request<{
  data: PsychiatryOnlyUtmSource[];
}>('/api/v1/onboarding/psychiatry_only_utm_sources');


export const getPatientPsychiatryOnlyUtmSource = (patientId: string) => restClient.request<{
  data: PsychiatryOnlyUtmSource | null;
}>(`/api/v1/patient/${patientId}/psychiatry_only_utm_source`);


export const adminGetPsychiatryOnlyUtmSources = () => restClient.request<{
  data: PsychiatryOnlyUtmSource[];
}>('/api/v1/admin/psychiatry_only_utm_sources');


export type AddPsychiatryOnlyUtmSourceParams = Pick<PsychiatryOnlyUtmSource, 'value' | 'partner' | 'description' | 'isPaidTraffic' | 'active'>;
export const adminAddPsychiatryOnlyUtmSources = (data: AddPsychiatryOnlyUtmSourceParams) => restClient.request('/api/v1/admin/psychiatry_only_utm_sources', {
  method: 'POST',
  data: snakecaseKeys(data)
});


export type UpdatePsychiatryOnlyUtmSourceParams = Pick<PsychiatryOnlyUtmSource, 'value' | 'partner' | 'description' | 'isPaidTraffic' | 'active'>;
export const adminUpdatePsychiatryOnlyUtmSource = ({ value, ...data }: UpdatePsychiatryOnlyUtmSourceParams) => restClient.request(`/api/v1/admin/psychiatry_only_utm_sources/${encodeURIComponent(value)}`, {
  method: 'PUT',
  data: snakecaseKeys(data)
});
